import React, { useCallback } from "react"

import { useAppContext } from "@providers/app"

import { useCore } from "@hooks/useCore"
import { useMedia } from "@hooks/useMedia"

import GiftRegistryDrawerDesktop from "./DrawerDesktop"
import GiftRegistryDrawerMobile from "./DrawerMobile"

export interface GiftRegistryDrawerProps {
  handleClose: VoidFunction
  quantity: any
  grProductData: any
  setShowPasswordDrawer: any
  setGiftRegistryId: number
}

const GiftRegistryDrawer: React.FC<GiftRegistryDrawerProps> = ({ quantity, grProductData, setShowPasswordDrawer, setGiftRegistryId }) => {
  const { dispatch } = useAppContext()

  const {
    helpers: { ErrorBoundary },
  } = useCore()
  const { isBase } = useMedia()

  const handleClose = useCallback(() => {
    dispatch({
      type: "giftRegistryDrawer",
      payload: { activeGiftRegistryDrawer: false },
    })
  }, [dispatch])

  return (
    <ErrorBoundary>
      {isBase ? (
        <GiftRegistryDrawerMobile
          handleClose={handleClose}
          quantity={quantity}
          grProductData={grProductData}
          setShowPasswordDrawer={setShowPasswordDrawer}
          setGiftRegistryId={setGiftRegistryId}
        />
      ) : (
        <GiftRegistryDrawerDesktop
          handleClose={handleClose}
          quantity={quantity}
          grProductData={grProductData}
          setShowPasswordDrawer={setShowPasswordDrawer}
          setGiftRegistryId={setGiftRegistryId}
        />
      )}
    </ErrorBoundary>
  )
}

export default React.memo(GiftRegistryDrawer)
